import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d31bbec")

_pushScopeId("data-v-6d31bbec")
const _hoisted_1 = { class: "logoff_hd flex_space_center" }
const _hoisted_2 = { class: "hd_left flex_start_center" }
const _hoisted_3 = { class: "title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _ctx.viewModel.logo,
        class: "logo_icon",
        alt: ""
      }, null, 8, ["src"]),
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("span", {
      class: "hd_close",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickClose && _ctx.clickClose(...args)))
    })
  ]))
})